import { useMemo as e, createElement as r, memo as t, useState as n, useCallback as o, Fragment as i } from "react";
import { useTheme as a, useMotionConfig as l, useAnimatedPath as d, positionFromAngle as u, radiansToDegrees as c, usePropertyAccessor as s, DotsItem as f, useValueFormatter as m, bindDefs as g, useCurveInterpolation as v, Container as y, useDimensions as h, SvgWrapper as p, ResponsiveWrapper as b } from "@nivo/core";
import { BoxLegendSvg as x } from "@nivo/legends";
import { useSpring as B, animated as L, useSprings as S, to as k } from "@react-spring/web";
import { lineRadial as O, curveLinearClosed as C, arc as I } from "d3-shape";
import { useInheritedColor as M, getInheritedColorGenerator as W, useOrdinalColorScale as K } from "@nivo/colors";
import { jsx as V, Fragment as D, jsxs as Y } from "react/jsx-runtime";
import { useTooltip as w, Chip as A, TableTooltip as F } from "@nivo/tooltip";
import { scaleLinear as P } from "d3-scale";

function X() {
  return X = Object.assign || function (e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];

      for (var n in t) {
        Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
      }
    }

    return e;
  }, X.apply(this, arguments);
}

function z(e, r) {
  if (null == e) return {};
  var t,
      n,
      o = {},
      i = Object.keys(e);

  for (n = 0; n < i.length; n++) {
    t = i[n], r.indexOf(t) >= 0 || (o[t] = e[t]);
  }

  return o;
}

var T = function T(r) {
  var t,
      n = r.data,
      o = r.item,
      i = r.colorByKey,
      u = r.fillByKey,
      c = r.radiusScale,
      s = r.angleStep,
      f = r.curveFactory,
      m = r.borderWidth,
      g = r.borderColor,
      v = r.fillOpacity,
      y = r.blendMode,
      h = a(),
      p = M(g, h),
      b = e(function () {
    return O().radius(function (e) {
      return c(e);
    }).angle(function (e, r) {
      return r * s;
    }).curve(f);
  }, [c, s, f]),
      x = l(),
      S = x.animate,
      k = x.config,
      C = d(b(n.map(function (e) {
    return e[o];
  }))),
      I = B({
    fill: i[o],
    stroke: p({
      key: o,
      color: i[o]
    }),
    config: k,
    immediate: !S
  }),
      W = null != (t = u[o]) ? t : I.fill;
  return V(L.path, {
    d: C,
    fill: W,
    fillOpacity: v,
    stroke: I.stroke,
    strokeWidth: m,
    style: {
      mixBlendMode: y
    }
  }, o);
},
    j = function j(e) {
  var t = e.radius,
      n = e.angles,
      o = e.indices,
      i = e.label,
      a = e.labelOffset,
      d = l(),
      s = d.animate,
      f = d.config,
      m = o.map(function (e, r) {
    var o,
        i,
        l = u(n[r], t + a),
        d = (o = n[r], (i = c(o) + 90) <= 10 || i >= 350 || i >= 170 && i <= 190 ? "middle" : i > 180 ? "end" : "start");
    return X({
      id: e,
      angle: c(n[r]),
      anchor: d
    }, l);
  }),
      g = S(m.length, m.map(function (e) {
    return {
      transform: "translate(" + e.x + ", " + e.y + ")",
      config: f,
      immediate: !s
    };
  }));
  return V(D, {
    children: g.map(function (e, t) {
      var n = m[t];
      return r(i, {
        key: n.id,
        id: n.id,
        anchor: n.anchor,
        angle: n.angle,
        x: n.x,
        y: n.y,
        animated: e
      });
    })
  });
},
    E = ["shape"],
    H = t(function (e) {
  var r = e.radius,
      t = a(),
      n = l(),
      o = n.animate,
      i = n.config,
      d = B({
    radius: r,
    config: i,
    immediate: !o
  });
  return V(L.circle, X({
    fill: "none",
    r: k(d.radius, function (e) {
      return Math.max(e, 0);
    })
  }, t.grid.line));
}),
    G = function G(r) {
  var t = r.radius,
      n = r.angleStep,
      o = r.dataLength,
      i = a(),
      l = e(function () {
    return O().angle(function (e) {
      return e * n;
    }).radius(t).curve(C);
  }, [n, t]),
      u = Array.from({
    length: o
  }, function (e, r) {
    return r;
  }),
      c = d(l(u));
  return V(L.path, X({
    fill: "none",
    d: c
  }, i.grid.line));
},
    R = function R(e) {
  var r = e.shape,
      t = z(e, E);
  return "circular" === r ? V(H, {
    radius: t.radius
  }) : V(G, X({}, t));
},
    q = function q(r) {
  var t = r.indices,
      n = r.levels,
      o = r.shape,
      i = r.radius,
      l = r.angleStep,
      d = r.label,
      c = r.labelOffset,
      s = a(),
      f = e(function () {
    return {
      radii: Array.from({
        length: n
      }).map(function (e, r) {
        return i / n * (r + 1);
      }).reverse(),
      angles: Array.from({
        length: t.length
      }, function (e, r) {
        return r * l - Math.PI / 2;
      })
    };
  }, [t, n, i, l]),
      m = f.radii,
      g = f.angles;
  return Y(D, {
    children: [g.map(function (e, r) {
      var t = u(e, i);
      return V("line", X({
        x1: 0,
        y1: 0,
        x2: t.x,
        y2: t.y
      }, s.grid.line), "axis." + r);
    }), m.map(function (e, r) {
      return V(R, {
        shape: o,
        radius: e,
        angleStep: l,
        dataLength: t.length
      }, "level." + r);
    }), V(j, {
      radius: i,
      angles: g,
      indices: t,
      labelOffset: c,
      label: d
    })]
  });
},
    J = function J(t) {
  var i = t.datum,
      l = t.keys,
      d = t.index,
      c = t.formatValue,
      s = t.colorByKey,
      f = t.radius,
      m = t.startAngle,
      g = t.endAngle,
      v = t.arcGenerator,
      y = t.tooltip,
      h = n(!1),
      p = h[0],
      b = h[1],
      x = a(),
      B = w(),
      L = B.showTooltipFromEvent,
      S = B.hideTooltip,
      k = e(function () {
    var e = l.map(function (e) {
      return {
        color: s[e],
        id: e,
        value: i[e],
        formattedValue: c(i[e], e)
      };
    });
    return e.sort(function (e, r) {
      return e.value - r.value;
    }), e.reverse(), e;
  }, [i, l, c, s]),
      O = o(function (e) {
    b(!0), L(r(y, {
      index: d,
      data: k
    }), e);
  }, [L, y, d, k]),
      C = o(function () {
    b(!1), S();
  }, [S, b]),
      I = e(function () {
    var e = u(m + .5 * (g - m) - Math.PI / 2, f);
    return {
      path: v({
        startAngle: m,
        endAngle: g
      }),
      tipX: e.x,
      tipY: e.y
    };
  }, [m, g, f, v]),
      M = I.path,
      W = I.tipX,
      K = I.tipY;
  return Y(D, {
    children: [p && V("line", {
      x1: 0,
      y1: 0,
      x2: W,
      y2: K,
      style: x.crosshair.line
    }), V("path", {
      d: M,
      fill: "#F00",
      fillOpacity: 0,
      onMouseEnter: O,
      onMouseMove: O,
      onMouseLeave: C
    })]
  });
},
    N = function N(e) {
  var r = e.data,
      t = e.keys,
      n = e.getIndex,
      o = e.formatValue,
      i = e.colorByKey,
      a = e.radius,
      l = e.angleStep,
      d = e.tooltip,
      u = I().outerRadius(a).innerRadius(0),
      c = -(.5 * l);
  return V(D, {
    children: r.map(function (e) {
      var r = n(e),
          s = c;
      return c += l, V(J, {
        datum: e,
        keys: t,
        index: r,
        formatValue: o,
        colorByKey: i,
        startAngle: s,
        endAngle: s + l,
        radius: a,
        arcGenerator: u,
        tooltip: d
      }, r);
    })
  });
},
    Q = function Q(r) {
  var t = r.data,
      n = r.keys,
      o = r.getIndex,
      i = r.colorByKey,
      l = r.radiusScale,
      d = r.angleStep,
      c = r.symbol,
      m = r.size,
      g = void 0 === m ? 6 : m,
      v = r.color,
      y = void 0 === v ? {
    from: "color"
  } : v,
      h = r.borderWidth,
      p = void 0 === h ? 0 : h,
      b = r.borderColor,
      x = void 0 === b ? {
    from: "color"
  } : b,
      B = r.enableLabel,
      L = void 0 !== B && B,
      S = r.label,
      k = void 0 === S ? "value" : S,
      O = r.formatValue,
      C = r.labelYOffset,
      I = a(),
      M = W(y, I),
      K = W(x, I),
      Y = s(k),
      w = e(function () {
    return t.reduce(function (e, r, t) {
      var a = o(r);
      return n.forEach(function (n) {
        var o = r[n],
            c = {
          index: a,
          key: n,
          value: o,
          formattedValue: O(o, n),
          color: i[n]
        };
        e.push({
          key: n + "." + a,
          label: L ? Y(c) : void 0,
          style: X({
            fill: M(c),
            stroke: K(c)
          }, u(d * t - Math.PI / 2, l(r[n]))),
          data: c
        });
      }), e;
    }, []);
  }, [t, n, o, i, L, Y, O, M, K, d, l]);
  return V(D, {
    children: w.map(function (e) {
      return V(f, {
        x: e.style.x,
        y: e.style.y,
        symbol: c,
        size: g,
        color: e.style.fill,
        borderWidth: p,
        borderColor: e.style.stroke,
        label: e.label,
        labelYOffset: C,
        datum: e.data
      }, e.key);
    })
  });
},
    U = {
  layers: ["grid", "layers", "slices", "dots", "legends"],
  maxValue: "auto",
  curve: "linearClosed",
  borderWidth: 2,
  borderColor: {
    from: "color"
  },
  gridLevels: 5,
  gridShape: "circular",
  gridLabelOffset: 16,
  gridLabel: function gridLabel(e) {
    var r = e.id,
        t = e.anchor,
        n = e.animated,
        o = a();
    return V(L.g, {
      transform: n.transform,
      children: V("text", {
        style: o.axis.ticks.text,
        dominantBaseline: "central",
        textAnchor: t,
        children: r
      })
    });
  },
  enableDots: !0,
  dotSize: 6,
  dotColor: {
    from: "color"
  },
  dotBorderWidth: 0,
  dotBorderColor: {
    from: "color"
  },
  enableDotLabel: !1,
  dotLabel: "formattedValue",
  dotLabelYOffset: -12,
  colors: {
    scheme: "nivo"
  },
  fillOpacity: .25,
  blendMode: "normal",
  isInteractive: !0,
  sliceTooltip: function sliceTooltip(r) {
    var t = r.index,
        n = r.data,
        o = e(function () {
      return n.map(function (e) {
        return [V(A, {
          color: e.color
        }, e.id), e.id, e.formattedValue];
      });
    }, [n]);
    return V(F, {
      title: V("strong", {
        children: t
      }),
      rows: o
    });
  },
  legends: [],
  role: "img",
  animate: !0,
  motionConfig: "gentle",
  defs: [],
  fill: []
},
    Z = ["data"],
    $ = ["isInteractive", "animate", "motionConfig", "theme", "renderWrapper"],
    _ = function _(t) {
  var n = t.data,
      o = t.keys,
      a = t.indexBy,
      l = t.layers,
      d = void 0 === l ? U.layers : l,
      u = t.maxValue,
      c = void 0 === u ? U.maxValue : u,
      f = t.valueFormat,
      y = t.curve,
      b = void 0 === y ? U.curve : y,
      B = t.margin,
      L = t.width,
      S = t.height,
      k = t.borderWidth,
      O = void 0 === k ? U.borderWidth : k,
      C = t.borderColor,
      I = void 0 === C ? U.borderColor : C,
      M = t.gridLevels,
      W = void 0 === M ? U.gridLevels : M,
      D = t.gridShape,
      Y = void 0 === D ? U.gridShape : D,
      w = t.gridLabel,
      A = void 0 === w ? U.gridLabel : w,
      F = t.gridLabelOffset,
      j = void 0 === F ? U.gridLabelOffset : F,
      E = t.enableDots,
      H = void 0 === E ? U.enableDots : E,
      G = t.dotSymbol,
      R = t.dotSize,
      J = void 0 === R ? U.dotSize : R,
      $ = t.dotColor,
      _ = void 0 === $ ? U.dotColor : $,
      ee = t.dotBorderWidth,
      re = void 0 === ee ? U.dotBorderWidth : ee,
      te = t.dotBorderColor,
      ne = void 0 === te ? U.dotBorderColor : te,
      oe = t.enableDotLabel,
      ie = void 0 === oe ? U.enableDotLabel : oe,
      ae = t.dotLabel,
      le = void 0 === ae ? U.dotLabel : ae,
      de = t.dotLabelYOffset,
      ue = void 0 === de ? U.dotLabelYOffset : de,
      ce = t.colors,
      se = void 0 === ce ? U.colors : ce,
      fe = t.fillOpacity,
      me = void 0 === fe ? U.fillOpacity : fe,
      ge = t.blendMode,
      ve = void 0 === ge ? U.blendMode : ge,
      ye = t.isInteractive,
      he = void 0 === ye ? U.isInteractive : ye,
      pe = t.sliceTooltip,
      be = void 0 === pe ? U.sliceTooltip : pe,
      xe = t.legends,
      Be = void 0 === xe ? U.legends : xe,
      Le = t.role,
      Se = t.ariaLabel,
      ke = t.ariaLabelledBy,
      Oe = t.ariaDescribedBy,
      Ce = t.defs,
      Ie = void 0 === Ce ? U.defs : Ce,
      Me = t.fill,
      We = void 0 === Me ? U.fill : Me,
      Ke = h(L, S, B),
      Ve = Ke.margin,
      De = Ke.innerWidth,
      Ye = Ke.innerHeight,
      we = Ke.outerWidth,
      Ae = Ke.outerHeight,
      Fe = function (r) {
    var t = r.data,
        n = r.keys,
        o = r.indexBy,
        i = r.maxValue,
        a = r.valueFormat,
        l = r.curve,
        d = r.width,
        u = r.height,
        c = r.colors,
        f = void 0 === c ? U.colors : c,
        y = r.legends,
        h = r.defs,
        p = r.fill,
        b = s(o),
        x = e(function () {
      return t.map(b);
    }, [t, b]),
        B = m(a),
        L = K(f, "key"),
        S = e(function () {
      return n.reduce(function (e, r, t) {
        return e[r] = L({
          key: r,
          index: t
        }), e;
      }, {});
    }, [n, L]),
        k = e(function () {
      var e = n.map(function (e) {
        return {
          key: e,
          color: S[e],
          data: t,
          fill: null
        };
      }),
          r = g(h, e, p),
          o = e.reduce(function (e, r) {
        var t = r.key,
            n = r.fill;
        return e[t] = n, e;
      }, {});
      return {
        boundDefs: r,
        fillByKey: o
      };
    }, [n, t, h, p, S]),
        O = k.boundDefs,
        C = k.fillByKey,
        I = e(function () {
      var e = t.reduce(function (e, r) {
        return [].concat(e, n.map(function (e) {
          return r[e];
        }));
      }, []),
          r = "auto" !== i ? i : Math.max.apply(Math, e),
          o = Math.min(d, u) / 2;
      return {
        radius: o,
        radiusScale: P().range([0, o]).domain([0, r]),
        centerX: d / 2,
        centerY: u / 2,
        angleStep: 2 * Math.PI / t.length
      };
    }, [n, t, i, d, u]),
        M = I.radius,
        W = I.radiusScale,
        V = I.centerX,
        D = I.centerY,
        Y = I.angleStep,
        w = v(l),
        A = e(function () {
      return {
        data: t,
        keys: n,
        indices: x,
        colorByKey: S,
        centerX: V,
        centerY: D,
        radiusScale: W,
        angleStep: Y
      };
    }, [t, n, x, S, V, D, W, Y]),
        F = e(function () {
      return n.map(function (e) {
        return {
          id: e,
          label: e,
          color: S[e]
        };
      });
    }, [n, S]),
        T = e(function () {
      return y.map(function (e) {
        var r = e.data,
            t = z(e, Z),
            n = null == r ? void 0 : r.map(function (e) {
          return X({}, F.find(function (r) {
            return r.id === e.id;
          }) || {}, e);
        });
        return X({}, t, {
          data: n || F
        });
      });
    }, [y, F]);
    return {
      getIndex: b,
      indices: x,
      formatValue: B,
      colorByKey: S,
      fillByKey: C,
      boundDefs: O,
      radius: M,
      radiusScale: W,
      centerX: V,
      centerY: D,
      angleStep: Y,
      curveFactory: w,
      legendData: F,
      boundLegends: T,
      customLayerProps: A
    };
  }({
    data: n,
    keys: o,
    indexBy: a,
    maxValue: c,
    valueFormat: f,
    curve: b,
    width: De,
    height: Ye,
    colors: se,
    legends: Be,
    defs: Ie,
    fill: We
  }),
      Pe = Fe.getIndex,
      Xe = Fe.indices,
      ze = Fe.formatValue,
      Te = Fe.colorByKey,
      je = Fe.fillByKey,
      Ee = Fe.boundDefs,
      He = Fe.radius,
      Ge = Fe.radiusScale,
      Re = Fe.centerX,
      qe = Fe.centerY,
      Je = Fe.angleStep,
      Ne = Fe.curveFactory,
      Qe = Fe.boundLegends,
      Ue = Fe.customLayerProps,
      Ze = {
    grid: null,
    layers: null,
    slices: null,
    dots: null,
    legends: null
  };

  return d.includes("grid") && (Ze.grid = V("g", {
    transform: "translate(" + Re + ", " + qe + ")",
    children: V(q, {
      levels: W,
      shape: Y,
      radius: He,
      angleStep: Je,
      indices: Xe,
      label: A,
      labelOffset: j
    })
  }, "grid")), d.includes("layers") && (Ze.layers = V("g", {
    transform: "translate(" + Re + ", " + qe + ")",
    children: o.map(function (e) {
      return V(T, {
        data: n,
        item: e,
        colorByKey: Te,
        fillByKey: je,
        radiusScale: Ge,
        angleStep: Je,
        curveFactory: Ne,
        borderWidth: O,
        borderColor: I,
        fillOpacity: me,
        blendMode: ve
      }, e);
    })
  }, "layers")), d.includes("slices") && he && (Ze.slices = V("g", {
    transform: "translate(" + Re + ", " + qe + ")",
    children: V(N, {
      data: n,
      keys: o,
      getIndex: Pe,
      formatValue: ze,
      colorByKey: Te,
      radius: He,
      angleStep: Je,
      tooltip: be
    })
  }, "slices")), d.includes("dots") && H && (Ze.dots = V("g", {
    transform: "translate(" + Re + ", " + qe + ")",
    children: V(Q, {
      data: n,
      keys: o,
      getIndex: Pe,
      radiusScale: Ge,
      angleStep: Je,
      symbol: G,
      size: J,
      colorByKey: Te,
      color: _,
      borderWidth: re,
      borderColor: ne,
      enableLabel: ie,
      label: le,
      formatValue: ze,
      labelYOffset: ue
    })
  }, "dots")), d.includes("legends") && (Ze.legends = V(i, {
    children: Qe.map(function (e, r) {
      return V(x, X({}, e, {
        containerWidth: L,
        containerHeight: S
      }), r);
    })
  }, "legends")), V(p, {
    defs: Ee,
    width: we,
    height: Ae,
    margin: Ve,
    role: Le,
    ariaLabel: Se,
    ariaLabelledBy: ke,
    ariaDescribedBy: Oe,
    children: d.map(function (e, t) {
      var n;
      return "function" == typeof e ? V(i, {
        children: r(e, Ue)
      }, t) : null != (n = null == Ze ? void 0 : Ze[e]) ? n : null;
    })
  });
},
    ee = function ee(e) {
  var r = e.isInteractive,
      t = void 0 === r ? U.isInteractive : r,
      n = e.animate,
      o = void 0 === n ? U.animate : n,
      i = e.motionConfig,
      a = void 0 === i ? U.motionConfig : i,
      l = e.theme,
      d = e.renderWrapper,
      u = z(e, $);
  return V(y, {
    animate: o,
    isInteractive: t,
    motionConfig: a,
    renderWrapper: d,
    theme: l,
    children: V(_, X({
      isInteractive: t
    }, u))
  });
},
    re = function re(e) {
  return V(b, {
    children: function children(r) {
      var t = r.width,
          n = r.height;
      return V(ee, X({
        width: t,
        height: n
      }, e));
    }
  });
};

export { ee as Radar, Q as RadarDots, re as ResponsiveRadar, U as svgDefaultProps };